var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_575_32032)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6165 14.0942L15.3007 11.5275C15.1405 11.4039 14.9408 11.3429 14.739 11.356C14.5371 11.369 14.3469 11.4552 14.204 11.5983L12.444 13.3592C12.3129 13.4916 12.141 13.5759 11.956 13.5984C11.771 13.621 11.5839 13.5804 11.4248 13.4833C10.8582 13.1358 9.90983 12.4625 8.72316 11.275C7.5365 10.0892 6.86316 9.14001 6.51566 8.57418C6.41847 8.41526 6.37792 8.22812 6.40061 8.04322C6.42331 7.85832 6.50792 7.68654 6.64066 7.55584L8.40066 5.79501C8.54402 5.65217 8.63025 5.46188 8.64314 5.25992C8.65603 5.05796 8.5947 4.85825 8.47066 4.69834L5.90483 1.38168C5.3215 0.629178 4.2215 0.510011 3.50483 1.13918C2.56066 1.96751 1.4265 3.20834 1.0965 4.60084C0.498997 7.10918 1.44316 10.2567 5.59316 14.4067C9.74316 18.5558 12.8907 19.5008 15.3982 18.9042C16.7907 18.5725 18.0323 17.4375 18.8607 16.4942C19.489 15.7775 19.3698 14.6775 18.6165 14.0942Z",
    fill: "#414B56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_575_32032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.808adf1be3b613f49ad1b5633f664b90.svg";
export { ForwardRef as ReactComponent };